var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/bangbangstudio.ru/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/IndexComponents/Intro/Intro.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/IndexComponents/Intro/Intro.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["intro", "language"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("intro", Object.prototype.hasOwnProperty.call(kwargs, "intro") ? kwargs["intro"] : {});frame.set("language", Object.prototype.hasOwnProperty.call(kwargs, "language") ? kwargs["language"] : "");var t_5 = "";t_5 += "\n    <div class=\"Intro\">\n        ";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "intro"), env.opts.autoescape);
t_5 += "\n        <div class=\"Intro-wrapper\">\n            <div class=\"Intro-title--1\" data-fade-in-on-load>\n                ";
t_5 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "intro")),"title")), env.opts.autoescape);
t_5 += "\n            </div>\n        </div>\n        <div class=\"Intro-video\">\n            <a class=\"Intro-videoLink\" href=\"https://33.bangbangstudio.ru/\" target=\"_blank\">\n                <video class=\"lazy\" loop muted autoplay playsinline=\"true\" preload=\"none\">\n                    <source data-src=\"";
t_5 += runtime.suppressValue((lineno = 13, colno = 47, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, ["files/matreyo.mp4"])), env.opts.autoescape);
t_5 += "\" type='video/mp4; codecs=\"avc1.42E01E, mp4a.40.2\"'>\n                </video>\n            </a>\n            <div class=\"Intro-videoSound\">\n                <span class=\"on\">";
t_5 += runtime.suppressValue((lineno = 17, colno = 57, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["sound-on",runtime.makeKeywordArgs({"caller": (function (){var macro_t_6 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_7 = "";;
frame = frame.pop();
return new runtime.SafeString(t_7);
});
return macro_t_6;})()})])), env.opts.autoescape);
t_5 += "</span>\n                <span class=\"off hidden\">";
t_5 += runtime.suppressValue((lineno = 18, colno = 65, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["sound-off",runtime.makeKeywordArgs({"caller": (function (){var macro_t_8 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_9 = "";;
frame = frame.pop();
return new runtime.SafeString(t_9);
});
return macro_t_8;})()})])), env.opts.autoescape);
t_5 += "</span>\n            </div>\n            ";
if(runtime.contextOrFrameLookup(context, frame, "language") == "ru") {
t_5 += "\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "intro")),"file") != "None") {
t_5 += "\n                    <a class=\"Intro-videoFile\" href=";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "intro")),"file"), env.opts.autoescape);
t_5 += " target=\"_blank\">Скачать презентацию</a>\n                ";
;
}
t_5 += "\n            ";
;
}
else {
t_5 += "\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "intro")),"file") != "None") {
t_5 += "\n                    <a class=\"Intro-videoFile\" href=";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "intro")),"file"), env.opts.autoescape);
t_5 += " target=\"_blank\">Download presentation</a>\n                ";
;
}
t_5 += "\n            ";
;
}
t_5 += "\n\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("Intro");
context.setVariable("Intro", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/IndexComponents/Intro/Intro.jinja"] , dependencies)